import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { UnsavedAlertComponent } from 'src/app/shared/components/unsaved-alert/unsaved-alert.component';
import { HttpService } from 'src/app/shared/services/http.service';
import { TableService } from 'src/app/shared/services/tableService/table.service';

@Component({
  selector: 'app-add-edit-contact',
  standalone: false,
  templateUrl: './add-edit-contact.component.html',
  styleUrl: './add-edit-contact.component.scss',
})
export class AddEditContactComponent implements OnInit, AfterViewInit {
  public contactForm: FormGroup;
  public contactTypeList: any;
  public userData: any;
  public dataSource: any;
  public operation = 'add';
  public categoryList: any;
  public gsdbListArr: any;
  public selectedContactType: any;
  isValuesChanged: boolean = false;

  constructor(
    public appService: AppService,
    private httpService: HttpService,
    private tableService: TableService,
    private router: Router,
    private dialog: MatDialog
  ) {
    this.contactForm = new FormGroup({
      status: new FormControl(''),
      contactType: new FormControl('', Validators.required),
      lastName: new FormControl('', Validators.required),
      firstName: new FormControl(''),
      gsdb: new FormControl(''),
      company: new FormControl(''),

      jobTittle: new FormControl(''),
      email: new FormControl('', Validators.required),
      phone: new FormControl('', Validators.required),
      createdDate: new FormControl(''),
      modifiedDate: new FormControl(''),
      notes: new FormControl(''),
      buyerCode: new FormControl(''),
      buyerLocation: new FormControl(''),
      createdBy: new FormControl(''),
      lastModifiedName: new FormControl(''),
    });
    // this.getItemDataFromDB();
    let userData = sessionStorage.getItem('user-data');
    this.userData = userData ? JSON.parse(userData) : null;
    this.dataSource = history.state.data;
    this.operation = history.state.operation;
    this.toUpdateOnField();
    this.getGSDBFromCarrier();
    this.getContactType();
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.isValuesChanged = false;
    Object.keys(this.contactForm.controls).forEach((controlName) => {
      this.contactForm
        .get(controlName)!
        .valueChanges.subscribe((value: any) => {
          this.isValuesChanged = true;
        });
    });
  }

  toUpdateOnField() {
    this.contactForm.enable();
    if (this.operation === 'edit' && this.dataSource.Status === 'Terminated') {
      this.operation = this.dataSource.Iscopy ? 'edit' : 'view';
    }
    if (this.operation === 'add') {
      this.contactForm.patchValue({
        createdBy: this.userData.Email.includes('dhl')
          ? 'LLP User'
          : this.userData.Email,
        createdDate: this.appService.getWithFormatToday(),
        modifiedDate: '', //this.appService.getWithFormatToday(),
        lastModifiedName: '', //(this.userData.Email).includes('dhl')?'LLP User':this.userData.Email,
        contactType: '',
        gsdb: '',
      });
      return;
    }
    if (this.operation === 'view') {
      this.contactForm.disable();
    }
    this.selectedContactType = '' + this.dataSource.ContactTypeID;
    this.contactForm.patchValue({
      status: this.dataSource.status,
      contactType: this.dataSource.ContactTypeID,
      lastName: this.dataSource.LastName,
      firstName: this.dataSource.FirstName,
      gsdb: this.dataSource.CarrierID ? this.dataSource.CarrierID : '',
      company: this.dataSource.Company,

      jobTittle: this.dataSource.JobTitle,
      email: this.dataSource.Email,
      phone: this.dataSource.PhoneNumber,
      createdDate: this.tableService.checkOnInvalidDate(
        this.dataSource.CreatedOn
      ),
      modifiedDate: this.tableService.checkOnInvalidDate(
        this.dataSource.ModifiedOn
      ),
      notes: this.dataSource.Notes,
      // buyerCode:this.dataSource.BuyerCode,
      buyerLocation: this.dataSource.BuyerLocation,
      createdBy: this.dataSource.CreatedBy,
      lastModifiedName: this.dataSource.ModifiedBy,
    });
  }

  onKeyDown(event: KeyboardEvent, condition = false) {
    if (condition) return;
    event.preventDefault();
  }

  onOptionChange(val: any) {
    if (val === 'contactType') {
      this.selectedContactType = this.contactForm.get('contactType')?.value;
      this.contactForm.get('gsdb')?.setValue('');
      this.contactForm.get('company')?.setValue('');
      // this.contactForm.get('buyerCode')?.setValue('')
      this.contactForm.get('buyerLocation')?.setValue('');

      this.setAndRemoveValidator('gsdb', false);
      this.setAndRemoveValidator('company', false);
      // this.setAndRemoveValidator('buyerCode',false);
      this.setAndRemoveValidator('buyerLocation', false);

      if (this.selectedContactType === '19') {
        // this.contactForm.get('buyerCode')?.setValue('')
        this.contactForm.get('buyerLocation')?.setValue('');
        this.setAndRemoveValidator('gsdb', true);
        this.setAndRemoveValidator('company', true);
      } else if (this.selectedContactType === '20') {
        this.contactForm.get('gsdb')?.setValue('');
        this.contactForm.get('company')?.setValue('');
        // this.setAndRemoveValidator('buyerCode',true);
        this.setAndRemoveValidator('buyerLocation', true);
      }
    }
  }

  onGsdbSelect(val: any) {
    this.gsdbListArr.filter((item: any) => item.IsActive === true);
    // this.gsdbListArr.sort((a:any, b:any) => ((a.ContractGSDB).toLowerCase() > (b.ContractGSDB).toLowerCase()) ? 1 : -1);
    this.contactForm.patchValue({
      company: this.gsdbListArr.find(
        (i: any) => '' + i.CarrierID === '' + val.value
      )?.Name,
    });
    // this.contactForm.get('gsdb')?.value(this.gsdbListArr.find((i:any) => ""+i.CarrierID === ""+val.value)?.ContractGSDB);
  }
  setAndRemoveValidator(name: string, required: boolean) {
    this.contactForm
      .get(name)
      ?.setValidators(required ? Validators.required : null);
    this.contactForm.get(name)?.updateValueAndValidity();
  }

  getGSDBFromCarrier() {
    this.appService.isLoading = true;
    this.httpService.getCarrierDetails().subscribe((res: any) => {
      this.appService.isLoading = false;
      if (res) {
        this.gsdbListArr = res;
        if (
          this.gsdbListArr.length === 1 &&
          this.selectedContactType === '19'
        ) {
          this.contactForm
            .get('gsdb')
            ?.setValue(this.gsdbListArr[0]?.CarrierID);
          this.contactForm.get('company')?.setValue(this.gsdbListArr[0]?.Name);
        }
      }
    });
  }

  onGSDBUpdate() {
    this.gsdbListArr = this.gsdbListArr.filter(
      (item: any) => item.IsActive === true && item.Status !== 'Terminated'
    );
    this.gsdbListArr.sort((a: any, b: any) =>
      a.ContractGSDB.toLowerCase() > b.ContractGSDB.toLowerCase() ? 1 : -1
    );
  }

  getContactType() {
    this.appService.isLoading = true;
    this.httpService.getListOfData('Contact').subscribe((res: any) => {
      this.appService.isLoading = false;
      if (res) {
        this.categoryList = res;
        this.contactTypeList = res.filter(
          (item: any) => item.Category === 'ContactType'
        );
      }
    });
  }

  onDelete() {
    if (this.operation !== 'edit') {
      return;
    }
    if (this.userData.RoleID === 3) {
      return;
    }
    this.tableService.deleteItem(
      'Contact',
      'ContactID',
      this.dataSource.ContactID,
      this
    );
  }
  onCopy() {
    if (this.operation !== 'edit') {
      return;
    }
    if (this.userData.RoleID === 3) {
      return;
    }
    this.operation = 'add';
    // this.contactForm.get('email')?.setValue('')
    this.contactForm.patchValue({
      email: '',
      lastModifiedName: '',
      modifiedDate: '',
    });
  }
  onSave() {
    if (this.operation === 'view') {
      return;
    }
    if (this.userData.RoleID == 3) {
      return;
    }
    if (this.contactForm.invalid) {
      this.httpService.openSnackBar('Please fill all the required Field');
      return;
    }
    if (
      this.selectedContactType === '19' &&
      this.contactForm.get('gsdb')?.value === ''
    ) {
      this.httpService.openSnackBar('Please select GSDB');
      return;
    }
    let find: any = null;
    find = this.tableService.contactDBSOurce?.find(
      (item: any) =>
        item.Email.toLowerCase() ===
        this.contactForm.get('email')?.value.toLowerCase()
    );
    if (find && this.operation === 'add') {
      this.httpService.openSnackBar(
        'Email is already connected with Other Contact Item'
      );
      return;
    }

    let statusList = this.categoryList.filter(
      (item: any) => item.Category === 'ContactStatus'
    );
    let id = statusList.find(
      (item: any) => item.LookUpName === 'Not Active'
    )?.LookUpID;

    let body = {
      ContactID:
        this.operation === 'add'
          ? null
          : this.dataSource.Status === 'Terminated' && this.dataSource.Iscopy
          ? null
          : this.dataSource.ContactID,
      CarrierID:
        this.selectedContactType === '19'
          ? Number(this.contactForm.get('gsdb')?.value)
          : null,
      JobTitle: '' + this.contactForm.get('jobTittle')?.value,
      Email: '' + this.contactForm.get('email')?.value,
      FirstName: '' + this.contactForm.get('firstName')?.value,
      LastName: '' + this.contactForm.get('lastName')?.value,
      UserEmail: this.userData.Email,
      ContactTypeID: Number(this.contactForm.get('contactType')?.value),
      ContactStatusID:
        this.operation === 'add' ? id : this.dataSource.ContactStatusID,
      Notes: '' + this.contactForm.get('notes')?.value,
      BuyerCode:
        this.selectedContactType === '20'
          ? this.contactForm.get('buyerCode')?.value
          : '',
      BuyerLocation:
        this.selectedContactType === '20'
          ? this.contactForm.get('buyerLocation')?.value
          : '',
      PhoneNumber: '' + this.contactForm.get('phone')?.value,
    };
    this.appService.isLoading = true;
    this.httpService.setContactDetails(body).subscribe((res: any) => {
      this.appService.isLoading = false;
      this.httpService.openSnackBar(res[0].MSG);
      if (res[0].DuplicateFlag === 0) {
        this.router.navigateByUrl('/home/contact');
      }
    });
  }

  onbackCall() {
    if (this.isValuesChanged) {
      const dialogRef = this.dialog.open(UnsavedAlertComponent, {
        disableClose: false,
      });
      dialogRef.afterClosed().subscribe((evt: any) => {
        if (evt.operation === 'confirm') {
          this.router.navigateByUrl('/home/contact');
        }
      });
    } else {
      this.router.navigateByUrl('/home/contact');
    }
  }
}
